<template>
  <div class="audit">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="infoForm"
        label-position="rigth"
        label-width="100px"
        ref="infoForm"
        :rules="infoFormRule"
      >
        <div class="form-item-wrap">
          <el-form-item label="机构编号" prop="endId">
            <el-input
              v-model="infoForm.endId"
              style="width: 300px"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="business">
            <el-input
              v-model="infoForm.business"
              style="width: 300px"
              readonly
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="type">
            <el-input
              v-model="infoForm.type"
              style="width: 300px"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="infoForm.name"
              style="width: 300px"
              readonly
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="ERP编号" prop="erpId">
            <el-input
              v-model="infoForm.erpId"
              style="width: 300px"
              readonly
              @click.native="getErpCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="tel">
            <el-input v-model="infoForm.tel" style="width: 300px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="区域" prop="addressData">
            <el-cascader
              v-model="infoForm.addressData"
              placeholder="选择地址(可搜索)"
              :options="$store.state.citys"
              :props="{ value: 'value', label: 'label', checkStrictly: true }"
              style="width: 300px"
              filterable
              ref="addressSel"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              v-model="infoForm.address"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="业务员" prop="saleMan">
            <el-input
              v-model="infoForm.saleMan"
              style="width: 300px"
              readonly
              placeholder="请选择"
              @click.native="getSalemanList('refresh', 'saleMan')"
            ></el-input>
          </el-form-item>
          <el-form-item label="开票员" prop="invoiceMan">
            <el-input
              v-model="infoForm.invoiceMan"
              style="width: 300px"
              readonly
              placeholder="请选择"
              @click.native="getSalemanList('refresh', 'invoice')"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="物流" prop="logisticsCode">
            <el-input
              v-model="infoForm.logisticsName"
              style="width: 300px"
              readonly
              placeholder="请选择"
              @click.native="getLogisticsList('refresh')"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格区间" prop="PriceLevel">
            <el-input
              v-model="infoForm.PriceLevelName"
              style="width: 300px"
              readonly
              placeholder="请选择"
              @click.native="priceLevel('')"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="资质证书">
            <el-table
              :data="seniorityList"
              tooltip-effect="dark"
              style="
                width: 700px;
                border: 1px solid #ebeef5;
                border-bottom: none;
              "
            >
              <el-table-column label="序号" align="center" width="50">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="MaterialName"
                label="名称"
              >
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="MaterialUrl"
                label="证书"
              >
                <template slot-scope="scope">
                  <img-view
                    :imgList="[{ url: baseUrl + scope.row.MaterialUrl, id: 0 }]"
                  ></img-view>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>

        <div class="form-item-wrap">
          <el-form-item label="经营范围" prop="range">
            <div style="width: 800px">
              <div>
                <el-tag
                  v-for="(item, index) in rangeList"
                  :key="index"
                  closable
                  @close="tagClose(index)"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px"
                  >{{ item }}
                </el-tag>
              </div>
              <el-button type="primary" @click="getTableData"
                >增加经营范围</el-button
              >
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="回执意见" prop="des">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              style="width: 700px"
              rows="5"
              v-model="infoForm.des"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="">
            <el-button type="primary" @click="submit(2)">通过</el-button>
            <el-button type="info" @click="submit(0)">拒绝</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      :title="'经营范围'"
      :isMoreSel="true"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :allPage="allPage"
      @search="getTableData"
      @rowClick="rowClick"
      @moreSel="selDataOk"
      @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"
    ></tableDialog>

    <!-- 数据选择 -->
    <tableDialog
      v-if="isErpCode"
      :title="'ERP编号'"
      :searchValue="searchFormErp.name"
      :tableData="erpCodeList"
      :tableHead="erpCodeHead"
      :currPage.sync="currPageErp"
      :allPage="allPageErp"
      :tips="erpCodeTips"
      @search="getErpCode"
      @rowClick="setErpCode"
      @close="isErpCode = false"
    ></tableDialog>

    <!-- 业务员列表 -->
    <el-dialog
      title="请选择"
      :visible.sync="saleManDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入名称检索"
            v-model="saleManName"
            @keydown.native.enter="('search')"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getSalemanList('search')"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="salesmenList"
        stripe
        border
        tooltip-effect="dark"
        height="300px"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column
          v-if="searchType == 'saleMan'"
          label="开票员"
          prop="Name"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-else-if="searchType == 'invoice'"
          label="业务员"
          prop="Name"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="TelPhone"
          align="center"
          width="160"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleSalemanItem(scope)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage1"
        :pageSize="pageSize1"
        :currIndex="pageIndex1"
        @hanSiChange="hanSiChange1"
        @hanCurrChange="hanCurrChange1"
      ></pagination>
    </el-dialog>

    <!-- 物流公司列表 -->
    <el-dialog
      title="请选择"
      :visible.sync="logisticsDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="800px"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入名称检索"
            v-model="logistics"
            @keydown.native.enter="('search')"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getLogisticsList('search')"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="LogisticsList"
        stripe
        border
        tooltip-effect="dark"
        height="300px"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="LogisticsName"
          show-overflow-tooltip
          label="物流公司"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="LogisticsCode"
          show-overflow-tooltip
          label="编码"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleLogisticsItem(scope)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"
      ></pagination>
    </el-dialog>
    <!-- 价格等级 -->
    <tableDialog
      v-if="isPriceLevel"
      :title="'价格等级'"
      :searchValue="priceLevelSearch.name"
      :tableData="priceLevleList"
      :tableHead="priceLevleHead"
      :currPage.sync="priceLevlePage"
      :pageSize.sync="pageSizeData"
      :allPage="priceLevleAll"
      @search="getPriceLevel"
      @rowClick="setPriceLevle"
      @hanCurrChange="setPriceLevelPage"
      @hanSizesChange="hanSizesChange"
      @close="isPriceLevel = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "audit",
  data() {
    return {
      /**基本信息表单 */
      infoForm: {
        endId: "", // 机构ID
        business: "", // 单位名称
        type: "", // 客户类型
        name: "", // 姓名
        erpId: "", // erp编号/用户id
        tel: "", // 手机
        sex: "", // 性别
        birthday: "", // 生日
        email: "", // 邮箱
        address: "", // 地址
        range: "", // 经营范围
        des: "", // 回执意见
        saleMan: "", //业务员
        saleManId: "", //业务员Id
        invoiceMan: "", //开票员
        invoiceManId: "", //开票员
        logisticsCode: "", // 选择的物流公司
        logisticsName: "", // 选择的物流公司id
        Province: "", //省
        City: "",
        Prefecture: "",
        addressData: "",
        PriceLevel: "",
        PriceLevelName: "",
      },
      modalKey: 0,
      userId: "",
      entId: "",
      infoFormRule: {
        erpId: [mustFill],
        tel: [mustFill],
        // range: [mustFill],
        des: [mustFill],
        saleMan: [mustFill],
        invoiceMan: [mustFill],
      },
      seniorityList: [],
      rangeList: [],
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      isSelDataOkRep: false,
      searchForm: {
        name: "",
      },
      tableList: [],
      tableDataHead: {},
      // erp编号列表
      isErpCode: false,
      currPageErp: 1,
      allPageErp: 0,
      searchFormErp: {
        name: "",
      },
      erpCodeList: [],
      erpCodeHead: {},
      erpCodeTips: "",

      /**业务员/开票员列表 */
      searchType: "saleMan", //搜索类型 saleMan开票员  invoice业务员
      saleManDialog: false,
      saleManName: "", //查询关键词
      salesmenList: [],
      pageIndex1: 1,
      pageSize1: 20,
      allPage1: 0,

      /**物流公司选择 */
      logistics: "",
      logisticsDialog: false,
      currPage2: 1,
      pageSize2: 20,
      LogisticsList: [],
      allPage2: 0,
      // 价格等级相关
      priceLevelUserId: "", // 价格等级绑定的用户编号
      isPriceLevel: false,
      priceLevleList: [],
      priceLevleHead: {},
      priceLevelSearch: {
        name: "",
      },
      priceLevlePage: 1,
      pageSizeData: 10,
      priceLevleAll: 0,
    };
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.id) {
      this.userId = prams.id;
      this.getDetailed();
    }

    this.entId = window.localStorage.getItem("entId");
  },
  methods: {
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 绑定价格等级
    priceLevel() {
      this.getPriceLevel();
    },
    // 获取机构等级
    getPriceLevel(val, isRep) {
      this.priceLevelSearch.name = isRep ? val : this.priceLevelSearch.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        searchVal: this.priceLevelSearch.name,
        pageIndex: this.priceLevlePage,
        pageSize: this.pageSizeData,
      };
      this.$request({
        method: "post",
        url: "GoodsAdmin/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          this.priceLevleList = [];
          this.priceLevleAll = 0;
          if (res.success) {
            this.priceLevleAll = res.toTal;
            this.priceLevleList = (res.list || []).map((item) => ({
              id: item.PriceCode, // 价格等级编号
              name: item.PriceName, // 价格等级名称
            }));
            this.priceLevleHead = { id: "价格等级编号", name: "价格等级名称" };
            this.isPriceLevel = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 设置价格等级列表页码
    setPriceLevelPage(val) {
      this.priceLevlePage = val;
      this.getPriceLevel();
    },
    // 设置价格等级列表页码
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getPriceLevel();
    },
    getDetailed() {
      let data = {
        userId: this.userId,
      };
      this.$request({
        method: "post",
        url: "/Management/MemberAdmin/GetMemberRegistDetail",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            let data = res.dataModel;
            this.infoForm.endId = data.EntId;
            this.infoForm.business = data.BusinessName;
            this.infoForm.type = data.ClinetType;
            this.infoForm.name = data.MemberName;
            this.infoForm.tel = data.Telphone;
            // this.infoForm.sex = data.sex
            // this.infoForm.birthday = data.birthday
            // this.infoForm.email = data.email
            this.infoForm.addressData = data.AreaCode;
            console.log(data.AreaCode, "地址");

            this.infoForm.Province = data.Province;
            this.infoForm.City = data.City;
            this.infoForm.Prefecture = data.Prefecture;
            this.infoForm.address = data.Address;
            this.seniorityList = data.Material || [];
            // this.erpCodeTips = `单位名称：${this.infoForm.business}，手机号：${this.infoForm.tel}，地址：${this.infoForm.address}`
            // this.searchFormErp.name = this.infoForm.business
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    setPriceLevle(row) {
      this.infoForm.PriceLevel = row.id;
      this.infoForm.PriceLevelName = row.name;
      this.isPriceLevel = false;
    },
    changeDetSelect(key, treeData) {
      let arr = []; // 在递归时操作的数组
      let returnArr = []; // 存放结果的数组
      let depth = 0; // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN; // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j].id;
          if (childrenData[j].id == key) {
            returnArr = arr.slice(0, depthN + 1); //将目前匹配的数组，截断并保存到结果数组，
            break;
          } else {
            if (childrenData[j].children) {
              depth++;
              childrenEach(childrenData[j].children, depth);
            }
          }
        }
        return returnArr;
      }
      return childrenEach(treeData, depth);
    },
    // 获取erp编号列表
    getErpCode(val, isRep) {
      this.searchFormErp.name = isRep ? val : this.searchFormErp.name;
      let data = {
        memberId: this.userId,
        searchStr: this.searchFormErp.name,
        pageIndex: this.currPageErp,
        pageSize: 10,
      };
      this.$request({
        method: "post",
        url: "Member/AuditGetClientInfo",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.erpCodeList = res.list || [];
            this.erpCodeHead = {
              erp_dwbh: "ERP编号",
              businessname: "单位名称",
              telephone: "手机号",
              address: "地址",
            };
            this.allPageErp = res.toTal;
            this.isErpCode = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择erp编号
    setErpCode(row) {
      if (row) {
        this.infoForm.erpId = row.erp_dwbh;
        this.isErpCode = false;
      }
    },
    // 获取弹出框表格数据
    getTableData(val, isRep) {
      this.searchForm.name = isRep ? val : this.searchForm.name;
      let data = {
        entId: this.entId,
        pageIndex: this.currPage,
        pageSize: 10,
        sqlValue: this.searchForm.name,
        channel_id: 12,
        keyId: 0,
      };
      this.$request({
        method: "post",
        url: "Base/GetTableCategory",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableList = res.list;
            this.tableDataHead = {
              Id: "编号",
              entId: "机构编号",
              title: "名称",
              sort_id: "排序",
            };
            this.allPage = res.toTal;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 选择单条数据
    rowClick(row, isSelDataOk) {
      for (let i = 0; i < this.rangeList.length; i++) {
        if (this.rangeList[i] == row.title) {
          if (isSelDataOk === true) {
            this.isSelDataOkRep = true;
          } else {
            this.$message({
              message: "选择的数据已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.rangeList.push(row.title);
      this.infoForm.range = this.rangeList.join();
      this.dialogVisible = false;
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      selectedList.forEach((item) => {
        this.rowClick(item, true);
      });
      if (this.isSelDataOkRep) {
        this.$message({
          message: "选择的数据已在列表中",
          type: "warning",
        });
        this.isSelDataOkRep = false;
      }
    },
    // 标签删除
    tagClose(index) {
      this.rangeList.splice(index, 1);
      this.infoForm.range = this.rangeList.join();
    },
    /**提交表单 */
    submit(status) {
      let tips = "请确认信息，是否确认通过审核";
      let type = "success";
      if (status == 2) {
        tips = "请确认信息，是否确认通过审核";
        type = "success";
      } else if (status == 0) {
        tips = "是否拒绝通过审核";
        type = "warning";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          if (status == 2) {
            this.testForm(status);
          } else if (status == 0) {
            this.submitForm(status);
          }
        })
        .catch(() => {});
    },

    // 验证表单信息
    testForm(status) {
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          this.submitForm(status);
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },

    // 提交表单信息
    submitForm(status) {
      let addresData = this.$refs.addressSel.getCheckedNodes()[0] || {};
      let data = {
        UserId: this.userId, // 用户Id
        Status: status, // 状态
        Remark: this.infoForm.des, // 备注
        BusinessId: this.infoForm.erpId, // 用户编号
        UserSalesMan: {
          YwyId: this.infoForm.saleManId,
          YwyName: this.infoForm.saleMan,
          KpyId: this.infoForm.invoiceManId,
          KpyName: this.infoForm.invoiceMan,
        }, // 业务员开票员
        logisticsCode: this.infoForm.logisticsCode,
        Province: (addresData.pathLabels && addresData.pathLabels[0]) || "",
        City: (addresData.pathLabels && addresData.pathLabels[1]) || "",
        Area: (addresData.pathLabels && addresData.pathLabels[2]) || "",
        AreaCode: addresData.value || "",
        Address: this.infoForm.address,
        // telphone: this.infoForm.tel,
        // erpcode: this.infoForm.erpId,
        businesscont: this.infoForm.range,
        PriceLevel: this.infoForm.PriceLevel,
        // businesscont: ''
      };
      console.log(data, "shuju");
      this.$request({
        method: "post",
        // url: "Member/MemberRegistAudit",
        url: "/Management/MemberAdmin/MemberRegistAudit",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.goBack();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
            if (status == 0) {
              this.goBack();
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取业务员/开票员列表 */
    getSalemanList(load = "", searchType = this.searchType) {
      this.searchType = searchType;
      this.saleManDialog = true;
      // 需要根据选择的商品范围来判断获取不同的数据
      if (load == "refresh") {
        this.pageIndex1 = 1;
        this.saleManName = "";
      } else if (load == "search") {
        this.pageIndex1 = 1;
      }

      let department = "";
      if (this.searchType == "saleMan") {
        department = "业务员";
      } else if (this.searchType == "invoice") {
        department = "开票员";
      }

      this.$request({
        method: "post",
        url: "/Management/SalesManAdmin/GetSalesManList",
        data: {
          valStr: this.saleManName,
          status: 2,
          department: department,
          pageInde: this.pageIndex1,
          pageSize: this.pageSize1,
        },
      })
        .then((res) => {
          if (res.success) {
            this.salesmenList = res.dataList || [];
            this.allPage1 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange1(val) {
      this.pageSize1 = val;
      this.getSalemanList();
    },

    /**当前页改变 */
    hanCurrChange1(val) {
      this.pageIndex1 = val;
      this.getSalemanList();
    },

    /**选中某一项 */
    handleSalemanItem({ row }) {
      if (this.searchType == "saleMan") {
        this.infoForm.saleManId = row.UserId;
        this.infoForm.saleMan = row.Name;
      } else if (this.searchType == "invoice") {
        this.infoForm.invoiceManId = row.UserId;
        this.infoForm.invoiceMan = row.Name;
      }
      console.log(this.infoForm);
      this.saleManDialog = false;
    },

    /**获取物流公司 */
    getLogisticsList(type = "") {
      this.logisticsDialog = true;

      //函数太多 type: refresh search 不传参数默认加载
      if (type == "refresh") {
        this.currPage2 = 1;
        this.logistics = "";
      } else if (type == "search") {
        this.currPage2 = 1;
      }

      let data = {
        entId: this.entId,
        searchVal: this.logistics,
        status: "Y", //Y启用，N禁用
        pageIndex: this.currPage2,
        pageSize: this.pageSize2,
      };

      this.$request({
        url: "Base/LogisticsList",
        method: "post",
        data,
      })
        .then((res) => {
          this.LogisticsList = res.list;
          this.allPage2 = res.toTal;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getLogisticsList();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getLogisticsList();
    },

    /**选中某一个物流 */
    handleLogisticsItem({ row }) {
      this.logisticsDialog = false;
      this.infoForm.logisticsName = row.LogisticsName;
      this.infoForm.logisticsCode = row.LogisticsCode;
    },
  },
};
</script>

<style scoped>
.audit {
  width: 100%;
  height: 100%;
}
</style>
